import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import indexPriority from 'theme/z-index';

export default function CityCard({ data, onClick }) {
  return (
    <Container onClick={onClick}>
      <CityBackground
        src={data?.url}
        alt={data?.name}
      />
      <CityLabel>{data?.name}</CityLabel>
    </Container>
  );
}

const Container = styled.div`
  width: 180px;
  height: 200px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  transition: all ease-in-out 0.25s;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6) 0%, transparent 100%);
    border-radius: 0 0 12px 12px;
    z-index: ${indexPriority.medium};
    transition: background 0.25s ease;
  }

  &:hover::after {
    background: linear-gradient(to top, rgba(0, 0, 0, 0.75) 0%, transparent 100%);
  }
`;

const CityBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${indexPriority.none};
  transition: transform 0.5s ease;

  ${Container}:hover & {
    transform: scale(1.08);
  }
`;

const CityLabel = styled.p`
  position: absolute;
  bottom: 10px;
  left: 12px;
  color: ${colors.neutralLight};
  font-size: 14px;
  font-weight: 600;
  z-index: ${indexPriority.high};
  margin: 0;
`;
